import addressMixin from './address.mixin'
import announcementsModel from '@/models/announcements'
import invoicesModel from '@/models/invoices'
import accountingCatalogsModel from '@/models/accounting-catalogs'
import erpHooksModel from '@/models/erp-hooks'
import regionsModel from '@/models/regions'
import areasModel from '@/models/areas'
import routingZonesModel from '@/models/routing-zones'
import deliveryTimeRangesModel from '@/models/delivery-time-ranges'
import postalCodesModel from '@/models/postal-codes'
import takeBoosterConfigsModel from '@/models/take-booster-configs'
import transactionsModel from '@/models/transactions'
import codPaymentsModel from '@/models/cod-payments'
import codTransactionsModel from '@/models/cod-transactions'
import accountingNotesModel from '@/models/accounting-notes'
import pendingAccountingNotesModel from '@/models/pending-accounting-notes'
import personalPendingAccountingNotesModel from '@/models/personal-pending-accounting-notes'
import countriesModel from '@/models/countries'
import warehousesModel from '@/models/warehouses'
import warehouseSlotsModel from '@/models/warehouse-slots'
import companiesModel from '@/models/companies'
import vehicleCapacityModel from '@/models/vehicle-capacity'
import usersModel from '@/models/users'
import disableReasonsModel from '@/models/disable-reasons'
import couriersModel from '@/models/couriers'
import rolesModel from '@/models/roles'
import mobileAppsModel from '@/models/mobile-apps'
import permissionsModel from '@/models/permissions'
import fixedPricesModel from '@/models/fixed-prices'
import creditCardsModel from '@/models/credit-cards'
import fleetRentalOrdersModel from '@/models/fleet-rental-orders'
import receiverTypesModel from '@/models/receiver-types'
import shippingTypesModel from '@/models/shipping-types'
import shippingStatusReasonsModel from '@/models/shipping-status-reasons'
import shippingStatusReasonSettingsModel from '@/models/shipping-status-reason-settings'
import eventTypesModel from '@/models/event-types'
import eventsModel from '@/models/events'
import applicationsModel from '@/models/applications'
import ecosystemsModel from '@/models/ecosystems'
import platformsModel from '@/models/platforms'
import sizesModel from '@/models/sizes'
import vehicleTypesModel from '@/models/vehicle-types'
import notificationTypesModel from '@/models/notification-types'
import quotesModel from '@/models/quotes'
import servicesModel from '@/models/services'
import quoteServicesModel from '@/models/quote-services'
import quoteProvidersModel from '@/models/quote-providers'
import tourGenerationBotSettingsModel from '@/models/tour-generation-bot-settings'
import toursModel from '@/models/tours'
import shippingsModel from '@/models/shippings'
import addressesCheckModel from '@/models/addresses-check'
import itemPacksModel from '@/models/item-packs'
import itemsModel from '@/models/items'
import tagsModel from '@/models/tags'
import outsourcingQuotesModel from '@/models/outsourcing-quotes'
import outsourcingSlasModel from '@/models/outsourcing-slas'
import outsourcingModelMappingsModel from '@/models/outsourcing-model-mappings'
import outsourcingCustomizationsModel from '@/models/outsourcing-customizations'
import outsourcingCompanyCustomizationsModel from '@/models/outsourcing-company-customizations'
import shippingsContainersModel from '@/models/shippings-containers'
import shippingsInContainerModel from '@/models/shippingsInContainer'

export default {
  mixins: [addressMixin],
  computed: {
    models() {
      return {
        announcements: announcementsModel(this),
        invoices: invoicesModel(this),
        'accounting-catalogs': accountingCatalogsModel(this),
        'erp-hooks': erpHooksModel(this),
        // area_formulas: {
        //   title: this.$gettext('Area Formulas'),
        //   endpoint: 'area_formulas',
        //   fields: [
        //     {
        //       key: 'id',
        //       sortable: true
        //     },
        //     {
        //       key: 'area_id',
        //       label: this.$gettext('Area ID'),
        //       sortable: true,
        //       editable: true
        //     },
        //     {
        //       key: 'vehicle_type_id',
        //       label: this.$gettext('Vehicle Type'),
        //       type: 'Relationship',
        //       editable: true
        //     },
        //     {
        //       key: 'formula',
        //       label: this.$gettext('Formula'),
        //       editable: true
        //     },
        //     {
        //       key: 'courier_commission_formula',
        //       label: this.$gettext('Courier Commission Formula'),
        //       editable: true
        //     },
        //     {
        //       key: 'sort',
        //       label: this.$gettext('Sort'),
        //       type: Number,
        //       editable: true
        //     }
        //   ],
        //   filters: [
        //     'id',
        //     'area_id',
        //     'vehicle_type_id'
        //   ]
        // },
        regions: regionsModel(this),
        areas: areasModel(this),
        'routing-zones': routingZonesModel(this),
        'delivery-time-ranges': deliveryTimeRangesModel(this),
        'postal-codes': postalCodesModel(this),
        'take-booster-configs': takeBoosterConfigsModel(this),
        transactions: transactionsModel(this),
        'cod-payments': codPaymentsModel(this),
        'cod-transactions': codTransactionsModel(this),
        'accounting-notes': accountingNotesModel(this),
        'pending-accounting-notes': pendingAccountingNotesModel(this),
        'personal-pending-accounting-notes': personalPendingAccountingNotesModel(this),
        countries: countriesModel(this),
        warehouses: warehousesModel(this),
        'warehouse-slots': warehouseSlotsModel(this),
        companies: companiesModel(this),
        'vehicle-capacity': vehicleCapacityModel(this),
        users: usersModel(this),
        'disable-reasons': disableReasonsModel(this),
        couriers: couriersModel(this),
        roles: rolesModel(this),
        'mobile-apps': mobileAppsModel(this),
        permissions: permissionsModel(this),
        'fixed-prices': fixedPricesModel(this),
        'credit-cards': creditCardsModel(this),
        'fleet-rental-orders': fleetRentalOrdersModel(this),
        'receiver-types': receiverTypesModel(this),
        'shipping-types': shippingTypesModel(this),
        'shipping-status-reasons': shippingStatusReasonsModel(this),
        'shipping-status-reason-settings': shippingStatusReasonSettingsModel(this),
        'event-types': eventTypesModel(this),
        events: eventsModel(this),
        applications: applicationsModel(this),
        ecosystems: ecosystemsModel(this),
        platforms: platformsModel(this),
        sizes: sizesModel(this),
        'vehicle-types': vehicleTypesModel(this),
        'notification-types': notificationTypesModel(this),
        quotes: quotesModel(this),
        services: servicesModel(this),
        'quote-services': quoteServicesModel(this),
        'quote-providers': quoteProvidersModel(this),
        'tour-generation-bot-settings': tourGenerationBotSettingsModel(this),
        tours: toursModel(this),
        shippings: shippingsModel(this),
        'addresses-check': addressesCheckModel(this),
        'item-packs': itemPacksModel(this),
        items: itemsModel(this),
        tags: tagsModel(this),
        'outsourcing-quotes': outsourcingQuotesModel(this),
        'outsourcing-slas': outsourcingSlasModel(this),
        'outsourcing-model-mappings': outsourcingModelMappingsModel(this),
        'outsourcing-customizations': outsourcingCustomizationsModel(this),
        'outsourcing-company-customizations': outsourcingCompanyCustomizationsModel(this),
        'shippings-containers': shippingsContainersModel(this),
        shippingsInContainer: shippingsInContainerModel(this)
      }
    }
  }
  // NOTE (MOOV-5197): the registry is published to $appConfig.models by the
  // root component (App.vue) via an immediate watcher on this computed —
  // it is no longer reassigned on every component mount.
}
